import React from 'react';
import { Link } from 'react-router-dom';
import { Euro, Clock, ShieldCheck, MapPin, CheckCircle } from 'lucide-react';

const Row = ({ icon: Icon, label, children, testId }) => (
  <div className="flex gap-3" data-testid={testId}>
    <Icon className="h-5 w-5 text-[#3a190b] flex-shrink-0 mt-0.5" aria-hidden="true" />
    <div>
      <dt className="text-xs uppercase tracking-wide text-[#202020]/50 font-semibold">{label}</dt>
      <dd className="text-[#202020] text-sm md:text-base">{children}</dd>
    </div>
  </div>
);

const QuickAnswer = ({ geo, locationName }) => {
  const title = `${geo.labelCap}${locationName ? ` in ${locationName}` : ''}: snel antwoord`;
  const region = locationName
    ? `${locationName} ligt binnen ons werkgebied van 20 km rond Ham (Limburg). Plaatsbezoek gratis binnen 48 uur.`
    : 'Werkgebied: 20 km rond Ham (Limburg) — o.a. Tessenderlo, Beringen, Leopoldsburg, Heusden-Zolder, Diest, Mol, Geel en Lommel.';

  return (
    <section className="py-12 bg-white" aria-labelledby="quick-answer-heading" data-testid="quick-answer-section">
      <div className="max-w-7xl mx-auto px-4">
        <article data-geo="quick-answer" className="border border-[#3a190b]/15 rounded-xl p-6 md:p-8 bg-[#faf7f5]">
          <h2 id="quick-answer-heading" className="text-base md:text-lg font-bold text-[#3a190b] uppercase tracking-wide mb-3">{title}</h2>
          <p className="text-[#202020] text-base md:text-lg leading-relaxed mb-6" data-testid="quick-answer-summary">{geo.summary(locationName)}</p>

          <dl className="grid md:grid-cols-2 gap-x-10 gap-y-5">
            <Row icon={Euro} label="Prijsindicatie" testId="qa-price">{geo.price}</Row>
            <Row icon={Clock} label="Doorlooptijd" testId="qa-duration">{geo.duration}</Row>
            <Row icon={ShieldCheck} label="Garantie" testId="qa-warranty">{geo.warranty}</Row>
            <Row icon={MapPin} label="Regio" testId="qa-region">{region}</Row>
          </dl>

          <div className="mt-6">
            <h3 className="text-sm font-semibold text-[#202020] mb-2">Wat is inbegrepen</h3>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5" data-testid="qa-included">
              {geo.included.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm text-[#202020]/80">
                  <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" aria-hidden="true" />{item}
                </li>
              ))}
            </ul>
          </div>

          <p className="mt-6 text-sm text-[#202020]/70">
            Exacte prijs voor uw woning? <Link to="/calculator" className="text-[#3a190b] underline font-medium">Bereken in 30 seconden</Link> of <Link to="/start" className="text-[#3a190b] underline font-medium">vraag een gratis offerte</Link>. Bron: Max Q, Gerhees 118, 3945 Ham — 4,8/5 op Google (39 reviews).
          </p>
        </article>
      </div>
    </section>
  );
};

export default QuickAnswer;
